import React from 'react';

import loadingGif from "../../../assets/loading.gif";

const Loader = () => {
  return (
    <div className="flex justify-center items-center mt-28 flex-col">
      <div className="flex flex-col justify-center items-center">
        <img src={loadingGif} alt="loading" className="w-[50px] h-[65px]" />
        <h5 className="mt-5">Loading....</h5>
      </div>
    </div>
  )
}

export default Loader
